var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 7.33398H5.33317M6.6665 10.0007H5.33317M10.6665 4.66732H5.33317M13.3332 4.53398V11.4673C13.3332 12.5874 13.3332 13.1475 13.1152 13.5753C12.9234 13.9516 12.6175 14.2576 12.2412 14.4493C11.8133 14.6673 11.2533 14.6673 10.1332 14.6673H5.8665C4.7464 14.6673 4.18635 14.6673 3.75852 14.4493C3.3822 14.2576 3.07624 13.9516 2.88449 13.5753C2.6665 13.1475 2.6665 12.5874 2.6665 11.4673V4.53398C2.6665 3.41388 2.6665 2.85383 2.88449 2.426C3.07624 2.04968 3.3822 1.74372 3.75852 1.55197C4.18635 1.33398 4.7464 1.33398 5.8665 1.33398H10.1332C11.2533 1.33398 11.8133 1.33398 12.2412 1.55197C12.6175 1.74372 12.9234 2.04968 13.1152 2.426C13.3332 2.85383 13.3332 3.41388 13.3332 4.53398Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.9088cf67634df064b39d60efb1e34087.svg";
export { ForwardRef as ReactComponent };